module.exports = __webpack_public_path__ + "img/RZD.267f474a.svg";